module.exports = __webpack_public_path__ + "static/kirpichdom-7c27c91e65bc6f95d7085e44aff49aac.jpg";